angular.module("app")

.factory("eventosGridService", ['uiGridConstants', 'Restangular', '$timeout', '$filter', '$translate', function (uiGridConstants, Restangular, $timeout, $filter, $translate) {
    var service = {
        maleFemaleTemplate: function (propertyName) {
            return "<div class=\"ui-grid-cell-contents\">{{row.entity." + propertyName + "=='M'?"+$filter('translate')('persons.male')+":"+$filter('translate')('persons.female')+"}}</div>";
        },
        maleFemaleFilter: function (propertyName) {
            return {
                term: "",
                type: uiGridConstants.filter.SELECT,
                selectOptions: [{ value: 'M', label: $filter('translate')('persons.male') }, { value: 'F', label: $filter('translate')('persons.female') }]
            };
        }
    };
    return service;
}]);